export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";